
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import SplitType from 'split-type'

gsap.registerPlugin(ScrollToPlugin);

window.scrollAnimation = new (function () {
  this.scroller = false;
  this.init = function () {
    gsap.registerPlugin(ScrollTrigger)
    window.globalScroll.smooth.on('scroll', ScrollTrigger.update)
    gsap.ticker.add((time) => {
      window.globalScroll.smooth.raf(time * 1000)
    })

    gsap.ticker.lagSmoothing(0)
  }
  this.initGlobal = function () {
    let mm = gsap.matchMedia();

    let headerAnimation = gsap.timeline()


    headerAnimation.to('header', {
      "--dynamic-color": '#01683A',
      "--dynamic-opacity": 1,
    }, 'animationBg')
    ScrollTrigger.create({
      trigger: '[data-barba-namespace] .container:first-child',
      scrub: true,
      start: 'top top',
      end: "+=75%",
      animation: headerAnimation,


    });




  }


  this.trigger = []
  this.resetTrigger = function () {

    this.trigger.forEach(t => t.kill(true));
    let header = document.querySelector('header');
    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);

  }
  this.initView = function () {



    this.resetTrigger();
    let mm = gsap.matchMedia();

    const targetSplitting = document.querySelectorAll('[data-barba-namespace]:last-child [data-splitting]');


    ScrollTrigger.create({
      trigger: '.push-container',
      endTrigger: '.push-container h3',
      end: 'center center',
      scrub: true,
      pin: '.push-container .content',
      pinSpacing: false,
    });
    targetSplitting.forEach((el) => {
      const splitting = SplitType.create(el)

      splitting.lines.forEach((line, index) => {
        line.style.setProperty('--delay', `${index * 0.1}s`);
        ScrollTrigger.create({
          trigger: el,
          start: "top bottom", // Déclenchement quand l'élément entre dans le viewport
          onEnter: () => {
            line.classList.add('is-enter');
          },
          onEnterBack: () => {
            line.classList.remove('is-enter'); // Retirer la classe lorsque l'on revient en arrière
          },
        });
      });


    })

    const paths = document.querySelectorAll('[data-barba-namespace]:last-child .circuit_color');
    paths.forEach((path) => {
      const length = path.getTotalLength();
      console.log(length);
      path.style.setProperty('--stroke-dasharray', `${length / 2}`);
      gsap.fromTo(path, {
        '--stroke-dashoffset': length,
        repeat: -1,
        duration: 10,
        ease: 'none'
      }, {
        '--stroke-dashoffset': 0,
        repeat: -1,
        duration: 10,
        ease: 'none'


      })

    })



  }
  this.initEnterAnimation = function () {




  }


  this.lazyload = function () {
    gsap.utils.toArray("[data-barba-namespace]:last-of-type .container").forEach((section, i) => {
      ScrollTrigger.create({
        trigger: section,
        start: "-50% bottom",
        once: true,
        onEnter: () => {
          window.imageLoader.lazy(section);
        },
        onEnterBack: () => {
          window.imageLoader.lazy(section);
        }
      });
    });
  }
  this.update = function () {
    console.log('Test');
    ScrollTrigger.refresh()
  }
});
